const option = (value) => ({ label: value, value });

export const USER_CLASSIFICATION_TYPES = {
  industry_areas: 'IndustryArea',
  professional_goals: 'ProfessionalGoal',
  professional_skills: 'ProfessionalSkill',
  professional_roles: 'ProfessionalRole',
  interest_topics: 'InterestTopic',
  music_genres: 'MusicGenre',
  event_types: 'EventType',
  event_formats: 'EventFormat',
  event_attend_locations: 'EventAttendLocation',
};

export const toSelectValues = (items = []) =>
  items.map((item) => {
    if (typeof item === 'string') return option(item);
    return {
      label: item.name || item.label || item.value,
      value: item.id || item.value || item.name,
    };
  });

export const fromSelectValues = (items = []) =>
  items.map(({ value }) => value);

export const fromSelectValuesToIdObjects = (items = []) =>
  items.map(({ value }) => ({
    id: value,
  }));
